// The native iOS/Android apps stamp `platform=iOS` or `platform=Android` on the
// URLs they open. We use that to switch a post-submit/partner hand-off from a
// `window.open` (new tab) to a same-window navigation — the in-app browser has
// no tab concept, and a popup either silently drops or prompts the user to
// leave the host app.
const MOBILE_APP_PLATFORMS = new Set(['iOS', 'Android']);

const isMobileAppPlatform = (
  platform: string | string[] | undefined,
): boolean => {
  // The schema permits an array form to tolerate malformed iOS links where the
  // param appears twice; collapse to the first value before matching.
  const value = Array.isArray(platform) ? platform[0] : platform;
  return value !== undefined && MOBILE_APP_PLATFORMS.has(value);
};

export { isMobileAppPlatform };
